'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Seemore = function () {
    function Seemore(el) {
        _classCallCheck(this, Seemore);

        this.el = el;

        //events
        this.el.querySelectorAll('.see-more-btn')[0].addEventListener('click', this.onClick.bind(this));
        window.addEventListener('scroll', this.onScroll.bind(this));
        //variables
        this.isOpen = false;
        this.menuHeight = parseInt(this.el.getAttribute('data-paddingTop'));
        //regions
        this.content = this.el.querySelectorAll('.see-more-content')[0];
        this.inner = this.el.querySelectorAll('.see-more-content-inner')[0];
        this.header = this.el.querySelectorAll('.see-more-header')[0];
        this.span = this.el.querySelectorAll('.see-more-header span')[0];
        this.svg = this.el.querySelectorAll('.see-more-icon svg')[0];
        this.btn = this.el.querySelectorAll('.see-more-btn')[0];

        this.background = this.content.getAttribute('style');
    }

    _createClass(Seemore, [{
        key: 'onClick',
        value: function onClick(ev) {
            ev.preventDefault();
            if (this.isOpen === false) {
                this.toogle(false);
            } else if (this.isOpen === true) {
                this.toogle(true);
            }
        }
    }, {
        key: 'toogle',
        value: function toogle(open) {
            var _this = this;

            var scrollPos = domUtils.getScroll();
            var content = this.content.getBoundingClientRect();
            var body = document.body,
                html = document.documentElement;

            var height = domUtils.getDocumentHeight();
            var vh = domUtils.getViewHeight();
            var eh = parseFloat(window.getComputedStyle(this.inner).height) + 175;

            vh = vh > eh ? eh : vh;

            var shouldScroll = false;
            var elemPos = { y: 0 };

            if (open) {
                vh = vh > content.bottom ? content.bottom : vh;
                this.content.style.height = vh + 'px';
                this.content.style.transform = 'translateY(-50px) translateZ(1px)';
                this.header.style.transform = 'translateY(57px) translateZ(2px)';
                domUtils.removeClass(this.el, 'active');
                this.el.style.height = vh - 50 + 'px';
                if (content.top < this.menuHeight) {
                    elemPos.y = domUtils.getElementScrollPos(this.content) - this.menuHeight;
                    this.inner.style.marginTop = content.top + 'px';
                    shouldScroll = true;
                    document.documentElement.scrollTop = document.body.scrollTop = elemPos.y;
                }
            }

            domUtils.disableScroll();
            body.style.height = height + 'px';
            domUtils.addClass(body, 'see-more-animation');

            var animation = anime.timeline();

            animation.add({
                targets: this.header,
                translateY: open ? 0 : 57,
                duration: 600,
                translateZ: 2,
                easing: 'easeInOutCubic'
            }).add({
                targets: this.span,
                opacity: open ? 1 : 0,
                offset: 0,
                easing: 'easeInOutCubic'
            }).add({
                targets: this.svg,
                rotate: open ? '0deg' : '45deg',
                duration: 600,
                offset: 0,
                easing: 'easeInOutCubic'
            }).add({
                targets: body,
                translateY: shouldScroll ? domUtils.getViewHeight() / 3 : null,
                offset: 0,
                easing: 'easeInOutCubic'
            }).add({
                targets: this.el,
                height: open ? 0 : vh - 50,
                offset: 0,
                easing: 'easeInOutCubic'
            }).add({
                targets: this.content,
                height: open ? 0 : vh,
                translateY: open ? 0 : -50,
                translateZ: 1,
                offset: 0,
                easing: 'easeInOutCubic',
                complete: function complete(anim) {
                    if (!open) {
                        domUtils.addClass(_this.el, 'active');
                        document.documentElement.scrollTop = document.body.scrollTop = scrollPos[1];
                        domUtils.removeClass(_this.el, 'stick');
                    } else if (shouldScroll) {
                        document.documentElement.scrollTop = document.body.scrollTop = elemPos.y - domUtils.getViewHeight() / 3;
                    }
                    body.style.height = null;
                    body.style.transform = null;
                    domUtils.removeClass(body, 'see-more-animation');
                    domUtils.enableScroll();
                    $(_this.content).attr('style', _this.background);
                    $(_this.header).attr('style', '');
                    $(_this.inner).attr('style', '');
                    $(_this.el).attr('style', '');
                    _this.isOpen = !open;
                }
            });

            this.isOpen = 'process';
        }
    }, {
        key: 'onScroll',
        value: function onScroll(ev) {
            if (this.isOpen) {
                var scrollPos = window.pageYOffset;
                var content = this.content.getBoundingClientRect();
                if (content.top < this.menuHeight && content.bottom > this.menuHeight + 107) {
                    domUtils.addClass(this.el, 'stick');
                } else {
                    domUtils.removeClass(this.el, 'stick');
                }
            }
        }
    }]);

    return Seemore;
}();

var init = function init() {
    var elements = document.querySelectorAll('.see-more');
    Array.prototype.forEach.call(elements, function (el, i) {
        var seemore = new Seemore(el);
    });
};

domUtils.ready(init);
